"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFingerprintsAsync = void 0;
const buildSelectorKey_1 = require("./buildSelectorKey");
const normalizeXpath_1 = require("./normalizeXpath");
const hash = async (input) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
};
const createFingerprintsAsync = async (params) => {
    const { ruleId, node } = params;
    if (!node.target) {
        throw new Error('createFingerprints: node.target is required to create fingerprints');
    }
    const selectorKey = (selector) => (0, buildSelectorKey_1.buildSelectorKey)({
        ruleId,
        selector: selector,
        url: 'url' in params ? params.url : node.url
    });
    const fingerprints = await Promise.all([
        hash(selectorKey(node.target)),
        node.xpath && hash(selectorKey((0, normalizeXpath_1.normalizeXpath)(node.xpath))),
        node.ancestry && hash(selectorKey(node.ancestry))
    ]);
    return fingerprints.filter(Boolean);
};
exports.createFingerprintsAsync = createFingerprintsAsync;
//# sourceMappingURL=createFingerprintsAsync.js.map